import type { AdminOriginState } from "@/domains/certifications/types";
import { ADMIN_TABS } from "@/domains/certifications/routes";

export const ALL = "all";

export const TYPE_FILTERS = [ALL, "post", "comment"] as const;

export const VERDICT_FILTERS = [ALL, "OFF_TOPIC", "INCONCLUSIVE"] as const;

export const NOT_COUNTED_MODAL_WIDTH = 900;

export const FLAG_SKELETON_CARDS = 2;

export const FROM_DISCUSSION_FLAGS: AdminOriginState = {
  fromTab: ADMIN_TABS.COMMUNITY_FLAGS,
};
